import React from 'react';
import styled from 'styled-components';
import { Steps } from '@brokerbay/design-components';

const { Step } = Steps;

interface AppointmentDeskStepsProps {
  currentStep: number;
}

const AppointmentDeskSteps: React.FC<AppointmentDeskStepsProps> = ({
  currentStep,
}) => (
  <StyledStepsContainer>
    <Steps progressDot current={currentStep} dataCy="appointmentDesk-steps">
      <Step title="My Plan" dataCy="appointmentDesk-steps-myPlan" />
      <Step title="Activate" dataCy="appointmentDesk-steps-activate" />
      <Step title="Confirmation" dataCy="appointmentDesk-steps-confirmation" />
    </Steps>
  </StyledStepsContainer>
);

export default AppointmentDeskSteps;

const StyledStepsContainer = styled.div`
  width: max(600px, 80%);
  margin-bottom: 48px;
`;
